import React from 'react';
import { motion } from 'framer-motion';

interface DateRangeButtonsProps {
  onApply: () => void;
  isLoading: boolean;
}

export const DateRangeButtons: React.FC<DateRangeButtonsProps> = ({
  onApply,
  isLoading
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
      
      {/* Apply Button */}
      <motion.button
        type="button"
        onClick={onApply}
        disabled={isLoading}
        whileTap={{ scale: 0.97 }}
        whileHover={
          typeof window !== 'undefined' && window.innerWidth >= 768
            ? { scale: 1.02 }
            : {}
        }
        className="
          relative
          w-full sm:w-auto
          min-h-[44px]
          px-6 py-2
          text-sm font-medium text-white
          bg-[#EF4421]
          rounded-lg
          shadow-sm
          transition-colors duration-200
          disabled:opacity-50
          disabled:cursor-not-allowed
          flex items-center justify-center
          transform-gpu
          will-change-transform
        "
      >
        {/* Spinner - Centered when loading */}
        {isLoading ? (
          <svg
            className="animate-spin h-5 w-5"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        ) : (
          <span>Apply</span>
        )}
      </motion.button>
    </div>
  );
};
